<template>
  <w-icon-wrapper
    :height='24'
    :width='18'
    icon-name='work-favorite-icon'
    view-box='0 0 18 24'
  >
    <path
      id='_33_Favoriten_Icon'
      d='M19,2V19.911l-5.772-4.49L12,14.466l-1.228.955L5,19.911V2H19m2-2H3V24l9-7,9,7V0Z'
      data-name='33 Favoriten_Icon'
      fill='currentColor'
      transform='translate(-3)'
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconFavorite' };
</script>
